import { Injectable, isDevMode } from "@angular/core";
import { environment } from "../../environments/environment.development"

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

@Injectable({ providedIn: 'root' })
export class LoggerService {

  private level: LogLevel = environment.logLevel as LogLevel;

  setLevel(level: LogLevel) {
    this.level = level;
  }

  private shouldLog(level: LogLevel): boolean {
    const order: LogLevel[] = ['debug', 'info', 'warn', 'error'];
    return order.indexOf(level) >= order.indexOf(this.level);
  }

  log(level: LogLevel, ...args: any[]) {
    if (isDevMode() && this.shouldLog(level)) {
      console[level](...args);
    }

    if (!isDevMode() && level === 'error') {
      console.error(...args);
    }
  }

  debug(...args: any[]) { this.log('debug', '[DEBUG]', ...args); }
  info(...args: any[]) { this.log('info', '[INFO]', ...args); }
  warn(...args: any[]) { this.log('warn', '[WARN]', ...args); }
  error(...args: any[]) { this.log('error', '[ERROR]', ...args); }
}
